export default __webpack_public_path__ + "static/media/ttd_direktur.d10992a4.png";